/**
 * *************************************************************************************************
 * Responsibility - Renders a react portal in the form of a drawer opening from teh side. The drawer
 * is agnostic to its content. It only provides a safe layout for the content to be displayed.
 * ************************************************************************************************
 *
 * @format
 */

import {createPortal} from 'react-dom';
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

export const Drawer = props => {
    const {onClose, isOpen, children, className = ''} = props;

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    return createPortal(
        <div
            className={`${className} portal-drawer-47cj ${
                isOpen ? 'portal-drawer-47cj--open' : ''
            }`}>
            <div className={`portal-drawer-47cj__backdrop`} onClick={onClose}></div>
            <section className="portal-drawer-47cj__content">{children}</section>
        </div>,
        document.body
    );
};
export const DrawerHeader = props => {
    const {title, onCancel, onOk, cancelTitle, okTitle, children} = props;
    return (
        <div className={'portal-drawer-47cj__header'}>
            {!children ? (
                <div className="d-flex align-items-center justify-content-between">
                    <h4 className={'portal-drawer-header-47cj__title'}>{title || 'Title'}</h4>
                    <div className="portal-drawer-header-47cj__actions d-flex align-items-center justify-content-end">
                        {onCancel && (
                            <button className="btn btn--secondary" onClick={onCancel}>
                                {cancelTitle || 'Cancel'}
                            </button>
                        )}
                        {onOk && (
                            <button className="btn btn--primary" onClick={onOk}>
                                {okTitle || 'Ok'}
                            </button>
                        )}
                    </div>
                </div>
            ) : (
                children
            )}
        </div>
    );
};

export const DrawerFooter = props => {
    const {title, onCancel, onOk, cancelTitle, okTitle, children} = props;
    return (
        <div className={`portal-drawer-47cj__footer`}>
            {!children ? (
                <div className="d-flex align-items-center justify-content-between">
                    <h4 className={'portal-drawer-footer-47cj__title'}>{title || 'Title'}</h4>
                    <div className="portal-drawer-footer-47cj__actions d-flex align-items-center justify-content-end">
                        {onCancel && (
                            <button className="btn btn--secondary" onClick={onCancel}>
                                {cancelTitle || 'Cancel'}
                            </button>
                        )}
                        {onOk && (
                            <button className="btn btn--primary btn--large" onClick={onOk}>
                                {okTitle || 'Ok'}
                            </button>
                        )}
                    </div>
                </div>
            ) : (
                children
            )}
        </div>
    );
};

Drawer.propTypes = {
    onClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    children: PropTypes.node,
    className: PropTypes.string
};

DrawerHeader.propTypes = {
    title: PropTypes.string,
    onCancel: PropTypes.func,
    onOk: PropTypes.func,
    cancelTitle: PropTypes.string,
    okTitle: PropTypes.string,
    children: PropTypes.node
};

DrawerFooter.propTypes = {
    title: PropTypes.string,
    onCancel: PropTypes.func,
    onOk: PropTypes.func,
    cancelTitle: PropTypes.string,
    okTitle: PropTypes.string,
    children: PropTypes.node
};

// default props
Drawer.defaultProps = {
    children: null,
    className: ''
};
